<template>
  <div class="bonus-detail">
    <!-- ページタイトル -->
    <div class="page-title d-flex align-items-center">
      <div class="icon-area">
        <img src="@/assets/img/details_sub.jpg" alt="ボーナス明細" />
      </div>
      <h1 class="mb-0">ボーナス明細</h1>
    </div>

    <!-- タブ切り替え -->
    <div class="tab-area d-flex">
      <div class="tab-item active" @click="$emit('change-tab', 'monthly')">
        月次
      </div>
      <div class="tab-item" @click="$emit('change-tab', 'yearly')">年次</div>
      <!-- 2025/05/14 現状非表示
      <a :href="downloadUrl" target="_blank" class="tab-print" v-if="detailData.displayType === 'normal'"></a>
      -->
      <!-- 2025/08/19 作業中
      <a :href="downloadUrl" target="_blank" class="tab-print" v-if="detailData.displayType === 'a'">
        <i class="fa fa-print"></i> 印刷
      </a>
      -->
      <!--<a :href="downloadUrl" target="_blank" class="tab-print" v-if="detailData.displayType === 'normal' || detailData.displayType === 'expired'">-->
      <a :href="downloadUrl" target="_blank" class="tab-print" v-if="detailData.displayType === 'normal' || detailData.displayType == null && detailData.displayType_page == '0'">
        <i class="fa fa-print"></i> ダウンロード
      </a>
    </div>
    
    <!-- 明細コンテンツ部分 -->
    <div class="detail-content">
      <!-- 日付選択エリア -->
      <div class="date-selection py-2">
        <div class="d-flex justify-content-between align-items-center sp_column">
          <label>対象年月</label>
          <div class="date-selector d-flex">
            <div class="year-selector mr-2">
              <select v-model="selectedYear" @change="handleYearChange">
                <option v-for="year in computedYearOptions" :key="year" :value="year">
                  {{ year }}年
                </option>
              </select>
            </div>
            <div class="month-selector">
              <select
                v-model="selectedMonthValue"
                @change="handleMonthChange"
                :disabled="!selectedYear"
              >
                <option value="">月を選択</option>
                <option
                  v-for="month in monthOptions"
                  :key="month"
                  :value="month"
                >
                  {{ month }}月
                </option>
              </select>
            </div>
            <i class="fa fa-calendar ml-2"></i>
          </div>
        </div>
      </div>

      <!-- 適格請求書発行事業者登録 -->
      <div class="registration-area border-bottom py-2">
        <div class="d-flex justify-content-between">
          <label>適格請求書発行事業者登録番号</label>
          <label>{{ detailData.registration.registrationNumber }}</label>
        </div>
      </div>

      <!-- 状態に応じた表示コンポーネント -->
      <NormalPaymentInfo
        v-if="detailData.displayType === 'normal'"
        :payment-date="detailData.payment.date"
        :amount="totalPaymentAmount"
      />

      <ErrorPaymentInfo
        v-if="detailData.displayType === 'error'"
        :error-reason="detailData.payment.errorReason"
        :expiration-date="detailData.payment.expirationDate"
        :expirationManual-date="detailData.payment.expirationDateManual"
        :amount="detailData.payment.paymentInfo"
      />

      <ExpiredPaymentInfo
        v-if="detailData.displayType === 'expired'"
        :expiration-date="detailData.payment.expirationDate"
        :amount="detailData.payment.paymentInfo"
      />
      
      <!-- コミッション詳細セクション -->
      <CommissionDetailSection
        v-if="detailData.payment.amount != null"
        :commission-data="detailData.commission"
        :display="detailData.displayType"
        :fiscalYear="detailData.fiscalYear"
        :amount="detailData.payment.amount"
        :amountHead="detailData.payment.paymentInfo"
        @show-subsidiary="$emit('show-commission')"
      />

      <!-- 追加セクション -->
      <AddSection1
        v-for="(section, index) in filteredSections"
        :key="'add-section-' + index"
        :section-data="section"
        :fiscalYear="detailData.fiscalYear"
        :payment-display-type="section.displayType"
        :is-same-date-as-main="section.isSameDateAsMain"
        :is-same-as-prev-section="section.isSameAsPrevSection"
        :is-first-in-date-group="section.isFirstInDateGroup"
        :main-container-date="section.mainContainerDate"
        :has-registration-number="detailData.commission.hasRegistrationNumber"
        :islast="index == filteredSections.length - 1"
      />

      <!-- 会社情報 -->
      <div class="company-info text-right mt-3">
        <p class="mb-0">{{ detailData.registration.companyName }}</p>
        <p class="mb-0">
          登録番号：{{ detailData.registration.companyRegistrationNumber }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import NormalPaymentInfo from "./components/NormalPaymentInfo.vue";
import ErrorPaymentInfo from "./components/ErrorPaymentInfo.vue";
import ExpiredPaymentInfo from "./components/ExpiredPaymentInfo.vue";
import CommissionDetailSection from "./components/CommissionDetailSection.vue";
import AddSection1 from "./AddSection/AddSection1.vue";

export default {
  name: "BonusDetailContainer",
  components: {
    NormalPaymentInfo,
    ErrorPaymentInfo,
    ExpiredPaymentInfo,
    CommissionDetailSection,
    AddSection1,
  },
  props: {
    detailData: {
      type: Object,
      required: true,
    },
    additionalSections: {
      type: Array,
      default: () => [null],
    },
    // 初期選択日付から引き継ぐ値
    initialYear: {
      type: String,
      default: null
    },
    initialMonth: {
      type: String,
      default: null
    },
    yearOptions: {
      type: Array,
      default: () => []
    },
    currentYear: {
      type: Number,
      default: null
    },
    displayBaseMonth: {
      type: Number,
      default: null
    },
    fiscalYear: {
      type: String,
      default: '0'
    }
  },
  mounted() {
    console.log("BonusDetailContainer mounted");
    
    // 親コンポーネントから初期値を受け取る場合はそれを使用
    if (this.initialYear && this.initialMonth) {
      this.selectedYear = this.initialYear;
      this.selectedMonthValue = this.initialMonth;
      console.log("親コンポーネントからの初期値を設定:", this.selectedYear, this.selectedMonthValue);
    }
    
    // 月の選択肢を設定
    this.updateMonthOptions();
    // ダウンロードURLを設定
    this.updateDownloadUrl();
    
    // YYYY/MM形式のselectedMonthを設定（マウント時は変更通知しない）
    this.updateSelectedMonth(true);
    
    console.log(
      "初期表示 - 選択年月:",
      this.selectedYear,
      this.selectedMonthValue
    );
    console.log("初期表示 - 表示形式:", this.selectedMonth);
  },
  data() {
    // 現在の年月を取得（親から渡されない場合のデフォルト値）
    const now = new Date();
    const defaultCurrentYear = now.getFullYear();
    const defaultCurrentMonth = now.getMonth(); // 0-11の範囲（1月が0）
    const defaultDisplayBaseMonth = defaultCurrentMonth + 1; // 1-12の範囲に変換

    // 年月からYYYY/MMフォーマットに変換
    const formatYearMonth = (year, month) => {
      return `${year}/${month.toString().padStart(2, "0")}`;
    };

    // 初期値を現在の年と前月に設定（親から渡されない場合のデフォルト値）
    const initialYear = defaultCurrentYear;
    // 前月を設定（1月の場合は前年の12月）
    const initialMonth = defaultDisplayBaseMonth === 1 ? 12 : defaultDisplayBaseMonth - 1;
    const initialYearAdjusted =
      defaultDisplayBaseMonth === 1 ? initialYear - 1 : initialYear;
    return {
      selectedYear: initialYearAdjusted.toString(),
      selectedMonthValue: initialMonth.toString(),
      selectedMonth: formatYearMonth(initialYearAdjusted, initialMonth),
      monthOptions: [], // 月の選択肢は年に依存するため初期値は空
      downloadUrl: "",  // PDFダウンロード用のURL
      formatYearMonth, // formatYearMonthメソッドをdataに持たせる
    };
  },
  methods: {
    // 親から受け取らない場合にデフォルトで生成する関数
    generateYearOptions(currentYear) {
      // 現在の年から過去5年分の年を生成
      const years = [];
      for (let i = 0; i < 5; i++) {
        years.push((currentYear - i).toString());
      }
      return years;
    },
    handleYearChange() {
      // 年が変更されたら月を未選択に
      this.selectedMonthValue = "";
      // 年に基づいて月の選択肢を更新
      this.updateMonthOptions();
    },
    updateMonthOptions() {

      // 選択された年に基づいて利用可能な月の選択肢を設定
      const selectedYearNum = parseInt(this.selectedYear);
      // 親から渡されたcurrentYearがあればそれを使い、なければデフォルト値
      const currentYearNum = this.currentYear || new Date().getFullYear();
      // 親から渡されたdisplayBaseMonthがあればそれを使い、なければデフォルト値
      const baseMonth = this.displayBaseMonth || (new Date().getMonth() + 1);
      
      let availableMonths = [];

      // 詳細なデバッグログ
      console.log(
        "月選択肢更新 - 選択年:",
        selectedYearNum,
        "現在年:",
        currentYearNum,
        "基準月:",
        baseMonth
      );

      if (selectedYearNum === currentYearNum) {
        // 当年の場合、1月から前月までを表示（前月は含む、当月は含まない）
        const lastMonth = baseMonth === 1 ? 12 : baseMonth - 1;
        availableMonths = Array.from({ length: lastMonth }, (_, i) =>
          (i + 1).toString()
        );
        console.log("  当年のため 1月~前月までを表示。表示最終月:", lastMonth);
      } else if (selectedYearNum === currentYearNum - 4) {
        // 5年前の場合、表示基準月と同じ月から12月までを表示
        // 例: 現在が3月なら、5年前の3月から12月までを表示
        const startMonth = baseMonth;

        if (startMonth <= 12) {
          availableMonths = Array.from({ length: 13 - startMonth }, (_, i) =>
            (i + startMonth).toString()
          );
          console.log("  5年前のため 基準月(", startMonth, ")~12月までを表示");
        } else {
          console.log("  5年前だが基準月が12を超えているため表示なし");
        }
      } else {
        // その他の年の場合、すべての月を表示（2~4年前）
        availableMonths = Array.from({ length: 12 }, (_, i) =>
          (i + 1).toString()
        );
        console.log("  2~4年前のためすべての月(1~12)を表示");
      }

      this.monthOptions = availableMonths;

      // ログ出力で確認
      console.log(
        `  結果: Year ${selectedYearNum}: 現在年月=${currentYearNum}年${baseMonth}月, 表示月範囲:`,
        this.monthOptions
      );
    },
    handleMonthChange() {
      // 月が変更されたら年月の選択状態を更新
      this.updateSelectedMonth(false);
    },
    updateSelectedMonth(isMounting = false) {
      // 年と月が選択されている場合のみ更新
      if (this.selectedYear && this.selectedMonthValue) {
        this.selectedMonth = this.formatYearMonth(
          this.selectedYear,
          this.selectedMonthValue
        );
        
        // マウント時またはタブ切り替え時でなければ親に通知
        if (!isMounting) {
          this.handleDateChange();
        } else {
          // マウント時でも親コンポーネントに現在選択中の年月を通知（データは再取得しない）
          console.log("マウント時に年月を親に通知:", this.selectedMonth);
          this.$emit("date-changed", this.selectedMonth);
        }
        
        // 選択された年月に基づいてダウンロードURLを更新
        this.updateDownloadUrl();
      }
    },
    updateDownloadUrl() {
      // このURLはmounted時と年月変更時に更新される
      // detailDataとmemberプロパティが存在するかチェック
      const memberId = this.detailData && this.detailData.member ? this.detailData.member : "118188";
      const targetMonth = this.selectedMonth ? this.selectedMonth.replace("/", "") : 
                         (this.detailData && this.detailData.month) ? this.detailData.month.replace("/", "") : "";
      this.downloadUrl = `/Core/Common/NotificationWeb/PostForWeb?Member=${memberId}&TargetMonth=${targetMonth}&out=0`;
    },
    handleDateChange() {
      this.$emit("date-changed", this.selectedMonth);
    },
  },
  computed: {
    filteredSections() {
      //ディスプレイタイプがnormalでは無い場合はソートを行わない
      if(this.detailData.displayType !== 'normal'){
        //今後エラーの受注兼消滅日が追加される場合は、ここに処理を追加する
        console.log("ディスプレイタイプがnormalでは無い場合はソートを行わない");
        return this.additionalSections;
      }
      // 追加セクションが存在しない場合は空配列を返す
      if (!this.additionalSections || this.additionalSections.length === 0) {
        console.log("追加セクション: データなし");
        return [];
      }
      
      // nullや未定義の項目を除外し、有効なセクションのみを返す
      const validSections = this.additionalSections.filter(section => section);
      
      // 有効なセクションがない場合は空配列を返す
      if (validSections.length === 0) {
        console.log("追加セクション: 有効なデータなし");
        return [];
      }
      
      console.log("追加セクション処理前:", JSON.stringify(validSections));
      
      // メインコンテナの振込日
      const mainContainerDate = this.detailData.payment.date;
      
      // 振込日でソートし、同じ振込日のものをグループ化するために必要な情報を追加
      const mappedSections = validSections
        .map((section) => {
          // 振込日が親コンテナと同じかどうかのフラグ
          const isSameDateAsMain = section.paymentDate === mainContainerDate;
          
          // 各セクションは独自の表示タイプを持つべき（メインコンテナのタイプに依存しない）
          // デフォルトでは normal を使用
          const sectionDisplayType = section.displayType || 'normal';
          
          // セクションに追加情報を付与
          return {
            ...section,
            isSameDateAsMain,
            mainContainerDate,
            displayType: sectionDisplayType
          };
        })
        // 振込日でソートするが、メインコンテナと同じ日付のものを最上段に配置
        .sort((a, b) => {
          // メインコンテナと同じ日付のものを最優先
          if (a.isSameDateAsMain && !b.isSameDateAsMain) return -1;
          if (!a.isSameDateAsMain && b.isSameDateAsMain) return 1;
          
          // null値は最後に
          if (!a.paymentDate) return 1;
          if (!b.paymentDate) return -1;
          
          // 日付を比較して昇順ソート
          return a.paymentDate.localeCompare(b.paymentDate);
        });
      
      // 日付ごとにグループ化して金額を合計
      const dateGroups = {};
      
      // メインコンテナの支払い情報を事前に設定
      const mainPaymentStr = this.detailData.payment.paymentInfo || "0";
      const mainPaymentWithoutComma = mainPaymentStr.replace(/,/g, "");
      const mainPaymentAmount = parseFloat(mainPaymentWithoutComma);
      
      // 各日付グループを初期化
      mappedSections.forEach(section => {
        const date = section.paymentDate || 'no-date';
        if (!dateGroups[date]) {
          dateGroups[date] = {
            sections: [],
            totalAmount: 0
          };
        }
        
        // メインコンテナと同じ日付の場合、メインコンテナの金額も合計に追加
        if (date === mainContainerDate && !dateGroups[date].hasMainAmount) {
          dateGroups[date].totalAmount += isNaN(mainPaymentAmount) ? 0 : mainPaymentAmount;
          dateGroups[date].hasMainAmount = true;
        }
        
        dateGroups[date].sections.push(section);
        // カンマを除去してから数値に変換
        const amountStr = section.paymentInfo || "0";
        const amountWithoutComma = amountStr.replace(/,/g, "");
        const amount = parseFloat(amountWithoutComma);
        dateGroups[date].totalAmount += isNaN(amount) ? 0 : amount;
      });
      
      // ソート後に前のセクションと同じ日付かどうかを判定し、合計金額を割り当て
      const result = mappedSections.map((section, index) => {
        // 前のセクションの振込日情報を取得するための処理（ソート後なので再計算）
        const prevSectionDate = index > 0 ? mappedSections[index - 1].paymentDate : null;
        
        // 振込日が前のセクションと同じかどうかのフラグ
        const isSameAsPrevSection = section.paymentDate === prevSectionDate;
        
        const date = section.paymentDate || 'no-date';
        const isFirstInDateGroup = dateGroups[date].sections[0] === section;
        
        // 同じ日付の金額合計（最初のセクションにのみ設定）
        // NaNを避けるための処理を追加
        const groupTotalAmount = dateGroups[date].totalAmount;
        // 元の金額もカンマを除去して数値に変換
        const sectionAmountStr = section.paymentInfo || "0";
        const sectionAmountWithoutComma = sectionAmountStr.replace(/,/g, "");
        const sectionAmount = parseFloat(sectionAmountWithoutComma);
        const combinedAmount = isFirstInDateGroup ? groupTotalAmount : (isNaN(sectionAmount) ? 0 : sectionAmount);
        
        console.log(`ソート後セクション${index}:`, 
                  `日付=${section.paymentDate}`, 
                  `メイン日付=${mainContainerDate}`, 
                  `同日フラグ=${section.isSameDateAsMain}`, 
                  `前の日付=${prevSectionDate}`, 
                  `前と同日=${isSameAsPrevSection}`,
                  `合計金額=${combinedAmount}`);
        
        return {
          ...section,
          isSameAsPrevSection,
          isFirstInDateGroup,
          // 合計金額を文字列として設定（元のフォーマットを維持）
          // 3桁ごとにカンマを追加
          paymentInfo: isFirstInDateGroup ? String(combinedAmount).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : section.paymentInfo
        };
      });
      
      console.log("追加セクション処理後:", JSON.stringify(result));
      return result;
    },
    computedYearOptions() {
      // 親から渡されたyearOptionsがあればそれを使い、なければ生成する
      return this.yearOptions.length > 0 ? 
              this.yearOptions : 
              this.generateYearOptions(this.currentYear || new Date().getFullYear());
    },
    totalPaymentAmount() {
      // ディスプレイタイプがnormalでない場合は元の金額を返す
      if(this.detailData.displayType !== 'normal'){
        return this.detailData.payment.paymentInfo;
      }
      
      // メインコンテナの日付
      const mainContainerDate = this.detailData.payment.date;
      
      // 同じ日付の追加セクションがあるか確認
      const sameDateSections = (this.additionalSections || [])
        .filter(section => section && section.paymentDate === mainContainerDate);
      
      // 同じ日付のセクションがない場合は元の金額を返す
      if (sameDateSections.length === 0) {
        return this.detailData.payment.paymentInfo;
      }
      
      // メインコンテナの金額
      const mainAmountStr = this.detailData.payment.paymentInfo || "0";
      const mainAmountWithoutComma = mainAmountStr.replace(/,/g, "");
      const mainAmount = parseFloat(mainAmountWithoutComma);
      
      // 同じ日付の追加セクションの金額を合計
      let totalAdditionalAmount = 0;
      sameDateSections.forEach(section => {
        const amountStr = section.paymentInfo || "0";
        const amountWithoutComma = amountStr.replace(/,/g, "");
        const amount = parseFloat(amountWithoutComma);
        totalAdditionalAmount += isNaN(amount) ? 0 : amount;
      });
      
      // 合計金額を計算して3桁ごとにカンマを追加
      const totalAmount = (isNaN(mainAmount) ? 0 : mainAmount) + totalAdditionalAmount;
      return String(totalAmount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
};
</script>

<style scoped>
.bonus-detail {
  max-width: 800px;
  margin: 0 auto;
  font-family: "Hiragino Sans", "Meiryo", sans-serif;
  color: #333;
  background-color: #fff;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.header-logo img {
  height: 40px;
}

.text-center {
  text-align: center;
}

.my-3 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.page-title {
  border-radius: 0;
  padding: 10px 15px;
  margin: 20px 0;
}

.page-title h1 {
  font-size: 1.2em;
  font-weight: normal;
}

.icon-area img {
  width: 75px;
  margin-right: 15px;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.tab-area {
  margin-bottom: 20px;
  position: relative;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #ccc;
  color: #666;
  text-align: center;
  border-radius: 5px 5px 0 0;
  margin-right: 3px;
  flex: 1;
  max-width: 100px;
}

.tab-item.active {
  background-color: #e74c3c;
  color: white;
}

.tab-print {
  padding: 10px 20px;
  position: absolute;
  right: 0;
  background-color: #666;
  color: white;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
}

.detail-content {
  padding: 10px;
}

/* .date-selection select {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.year-selector select,
.month-selector select {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
}

.year-selector {
  width: 120px;
  margin-right: 10px;
} */

.month-selector {
  width: 120px;
}

.ml-2 {
  margin-left: 10px;
}

.mr-2 {
  margin-right: 10px;
}

.registration-area {
  margin-bottom: 15px;
}

.border-bottom {
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.py-2 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.justify-content-between {
  justify-content: space-between;
}

.company-info {
  font-size: 0.95em;
  margin-top: 40px;
}

.text-right {
  text-align: right;
}

.mt-3 {
  margin-top: 15px;
}

.mb-0 {
  margin-bottom: 0;
}

/* 共通デザインに調整 */
.btn {
    border: 1px solid #000 !important;
    padding: 10px 20px;
    color: #000 !important;
    font-weight: 300 !important;
    background-color: #fff;
    cursor: pointer;
}
button {
  font-family: Noto Sans JP, ヒラギノ角ゴ Pro, Hiragino Kaku Gothic Pro, メイリオ, Meiryo, sans-serif;
  line-height: 1.8 !important;
  color: #424242 !important;
  font-weight: 300 !important;
  font-size: 1.8rem;
}
select {
  width: 120px;
  height: 36px; 
  font-size: 1.2em;
  border: 1px solid #aaa;
  border-radius: 5px;
  box-sizing: border-box;
}

/* スマートフォンレイアウト */
@media screen and (min-width: 1px) and (max-width: 991px) {
  .sp_column {
    flex-direction: column;
    align-items: center;
  }
  .bonus-detail {
    padding: 20px 0px;
  }
}

</style> 